module.exports = __webpack_public_path__ + "img/pickup.1f54744f.png";